import { render, staticRenderFns } from "./DisclaimerBlock.vue?vue&type=template&id=cfdb48b6&scoped=true&"
import script from "./DisclaimerBlock.vue?vue&type=script&lang=ts&"
export * from "./DisclaimerBlock.vue?vue&type=script&lang=ts&"
import style0 from "./DisclaimerBlock.vue?vue&type=style&index=0&id=cfdb48b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdb48b6",
  null
  
)

export default component.exports